//
//

export default {
    name: "NoFunctionsPage",
    data() {
        return {};
    },
    methods: {
        emitAdd() {
            this.$emit("add");
        }
    }
};
